import { Link, Outlet, createRoute } from "@tanstack/react-router";
import { StaffGuard } from "@/components/StaffGuard";
import { UserMenu } from "@/components/UserMenu/UserMenu";
import { useAccessibleSurfaces } from "@/lib/auth/useAccessibleSurfaces";
import { rootRoute } from "./root";
import styles from "./staff.module.scss";

function StaffShell() {
  const { surfaces } = useAccessibleSurfaces();
  return (
    <div className={styles.shell}>
      <nav className={styles.topNav} aria-label="Operator console">
        <Link to="/staff" className={styles.brand}>
          Plotlounge Operator
        </Link>
        <div className={styles.navLinks}>
          <Link
            to="/staff/plotlounge-rooms"
            className={styles.navLink}
            activeProps={{
              className: `${styles.navLink} ${styles.navLinkActive}`,
            }}
          >
            Rooms
          </Link>
          <Link
            to="/staff/margaux/prompt"
            className={styles.navLink}
            activeProps={{
              className: `${styles.navLink} ${styles.navLinkActive}`,
            }}
          >
            Margaux prompt
          </Link>
          <Link
            to="/staff/facilitators"
            className={styles.navLink}
            activeProps={{
              className: `${styles.navLink} ${styles.navLinkActive}`,
            }}
          >
            Facilitators
          </Link>
          <Link
            to="/staff/discoverable-clubs"
            className={styles.navLink}
            activeProps={{
              className: `${styles.navLink} ${styles.navLinkActive}`,
            }}
          >
            Discoverable clubs
          </Link>
        </div>
        <div className={styles.navUser}>
          <UserMenu
            currentSurface="operator"
            accessibleSurfaces={surfaces}
            placement="topnav"
          />
        </div>
      </nav>
      <Outlet />
    </div>
  );
}

function StaffIndex() {
  return (
    <main className={styles.root}>
      <header className={styles.header}>
        <h1 className={styles.title}>Operator Console</h1>
        <p className={styles.subtitle}>Plotlounge — internal cockpit</p>
      </header>
      <section className={styles.placeholder}>
        <p>
          Use{" "}
          <Link to="/staff/plotlounge-rooms" className={styles.inlineLink}>
            Rooms
          </Link>{" "}
          to inspect Plotlounge room lifecycle and Margaux activity.
        </p>
      </section>
    </main>
  );
}

export const staffRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/staff",
  component: () => (
    <StaffGuard>
      <StaffShell />
    </StaffGuard>
  ),
});

export const staffIndexRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/",
  component: StaffIndex,
});
